"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculation_common_1 = require("./calculation-common");
class QuestionCompositionCalculator {
    constructor(options) {
        this.options = options;
        this.common = new calculation_common_1.Common(options.levelCount);
    }
    calculate(questionCounts, level) {
        const hardestLevel = this.common.hardestLevel(questionCounts);
        if (hardestLevel < 0) {
            return Array(this.options.levelCount).fill(0);
        }
        const startComposition = this.common.distributeComposition(questionCounts, hardestLevel, this.options.nonHardestReversedStartQuestions);
        const endComposition = this.common.distributeComposition(questionCounts, hardestLevel, this.options.nonHardestReversedEndQuestions);
        let hardest = this.calculateHardExponential(level);
        if (hardest > 1) {
            hardest = 1;
        }
        const remaining = 1 - hardest;
        let composition = [];
        for (let i = 0; i < hardestLevel; i++) {
            if (questionCounts[i] === 0) {
                composition.push(0);
                continue;
            }
            const current = this.calculateLine(startComposition[i], endComposition[i])(level);
            composition.push(current);
        }
        const sum = this.common.sum(composition);
        let distribution = [];
        if (sum === 0) {
            distribution = [...Array(hardestLevel).fill(0), 1];
        }
        else {
            for (let i = 0; i < hardestLevel; i++) {
                distribution.push(remaining / sum * composition[i]);
            }
            distribution.push(hardest);
        }
        distribution = [...distribution, ...Array(this.options.levelCount - distribution.length).fill(0)];
        return distribution;
    }
    calculateLine(y0, y1) {
        return (x) => {
            const m = y1 - y0 / (1 - 0);
            return m * x + y0;
        };
    }
    calculateHardExponential(x) {
        const exponential = (c, k, x0, y0) => {
            return (x) => c * Math.exp(k * (x + x0)) + y0;
        };
        const options = this.options.hardExponential;
        return exponential(options.c, options.k, options.x0, options.y0)(x);
    }
}
exports.QuestionCompositionCalculator = QuestionCompositionCalculator;
//# sourceMappingURL=question-composition-calculator.js.map